import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  padding: 32px 16px 24px 16px;
`;

export const ContentScroll = styled.div`
  overflow-y: auto;
  padding-bottom: 80px;
  width: 100%;
`;

export const ProgressContainer = styled.div`
  margin-top: 32px;
`;
